import React from 'react';
import ModuleCard from './ModuleItem';
import { WEBSITE_ROLES_MODEL } from '../Model/AllowedModules';
import CustomTabContainer from '../../../../../components/CustomTabContainer';
import CustomTab from '../../../../../components/CustomTab';
import WebsiteRolesApp from '../Functionality/WebsiteRolesApp';
import CustomTable from '../../../../../components/table/CustomTable';
import { CustomCheckbox } from '../../../../../components/CustomCheckbox';
/**
 * @Author: Susana Garcia Rodriguez
 * @JobTitle: Frontend - IBL
 * @Email: sgarcia@ibl.mx
 */

const WebsiteRoles = (props) => {
    const { web, selectedPermissions, setSelectedPermissions, readOnly } = props;
    const {
        t,
        selectedInnerView,
        handleStepSelectedInnerView,
        selectedRole,
        thead,
        tbody,
        selectedRoleCount,
        isAllChecked,
        handleSelectAll,
    } = WebsiteRolesApp({ web, selectedPermissions, setSelectedPermissions, readOnly });
    return (
        <div className='row'>
            <div className='col-12 px-0'>
                <CustomTabContainer
                    activeTab={selectedInnerView}
                    setActiveTab={handleStepSelectedInnerView}
                    className='rounded-top border-0 px-3'
                >
                    {(WEBSITE_ROLES_MODEL || []).map((role) => {
                        const Icon = role.icon;

                        const selectedCount = (selectedPermissions || []).filter((permission) =>
                            (web || []).some(
                                (item) =>
                                    item.id === permission.id &&
                                    role.children?.some((child) => child.id === item.moduleId),
                            ),
                        ).length;
                        return (
                            <CustomTab
                                key={role.id}
                                id={role.id}
                                title={t(role.translation)}
                                icon={<Icon className='h-24px w-24px' />}
                                newsNumber={selectedCount}
                                selected={selectedInnerView === role.id}
                                onClick={() => handleStepSelectedInnerView(role.id)}
                            />
                        );
                    })}
                </CustomTabContainer>
            </div>

            {selectedRole && (
                <div className='col-12 col-sm-6 col-lg-4 mt-4'>
                    <ModuleCard
                        icon={selectedRole.icon}
                        title={selectedRole.translation}
                        t={t}
                        count={selectedRoleCount}
                    />
                </div>
            )}
            <div className='mt-4'>
                <CustomCheckbox
                    trans={t('de_/_select_all').toUpperCase()}
                    checked={isAllChecked}
                    onChange={(e) => handleSelectAll(e.target.checked)}
                    disabled={readOnly}
                />
            </div>
            <div className={'col-12 p-0'}>
                <div className='overflow-auto'>
                    <CustomTable
                        tableId='tbl_wr_table'
                        searchId='tbl_wr_search_id'
                        thead={thead}
                        tbody={tbody}
                        checkbox={false}
                        columnActions={false}
                        withoutHeight={true}
                    />
                </div>
            </div>
        </div>
    );
};

export default WebsiteRoles;
